import moment from 'moment';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import StudentService from '../../../../services/student.service';
import Swal from 'sweetalert2';

export const handleSave = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    instituteId: string | undefined,
    benefitType: string,
    userSelectedBenefits: Record<string, any>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    const updatedUserInstiutes = state.data.userInstitutes.map((userInstitute: any) => {
        if (userInstitute.instituteId === instituteId) {
            return {
                ...userInstitute,
                benefitsSelection: JSON.stringify({
                    ...JSON.parse(userInstitute.benefitsSelection || '{}'),
                    [benefitType]: userSelectedBenefits
                }),
            };
        }
        return userInstitute;
    });

    const studentEntity = StudentService.toStudentEntity({
        id: state?.data?.id,
    });

    studentEntity.userInstitutes = updatedUserInstiutes;

    console.log(studentEntity, 'student entity with updated institutes');

    StudentService.pageSave(
        state?.data?.id,
        'alumni-benefits',
        studentEntity
    ).then((response) => {
        
        // refresh data after save
        dispatch({type: 'DATA_INIT', payload: { ...state, data: response?.data } });

        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Your Data have been updated successfully.',
            confirmButtonText: 'OK'
        });
    });

};

export const getYear = (token: string): number => {
    let year = 0;

    switch (token) {
        case 'CURRENT_YEAR_MINUS_1':
            year = moment().year() - 1;
            break;
        case 'CURRENT_YEAR_MINUS_2':
            year = moment().year() - 2;
            break;
        case 'CURRENT_YEAR_MINUS_10':
            year = moment().year() - 10;
            break;
        case 'CURRENT_YEAR_MINUS_11':
            year = moment().year() - 11;
            break;
        case 'CURRENT_YEAR_MINUS_99':
            year = moment().year() - 99;
            break;

        case 'CURRENT_YEAR':
            year = moment().year();
            break;
    }

    return year;
};
